<template>
  <div>
    <SelectList
      v-model="selectedValue"
      :clearable="clearable"
      :dense="dense"
      :emit-value="!emitObject"
      :label="getLabel"
      :option-label="optionLabel"
      :option-value="optionValue"
      :options="accountManagers"
      :rules="rules"
      v-bind="$attrs"
    >
      <template #option="scope">
        <QItem
          v-bind="scope.scope.itemProps"
          :style="scope.scope.opt.itemStyle"
        >
          <QItemSection>
            <QItemLabel>
              {{ scope.scope.opt[optionLabel] }}
            </QItemLabel>
            <QItemLabel caption>
              {{ scope.scope.opt.organisation.name }}
            </QItemLabel>
          </QItemSection>
        </QItem>
      </template>
    </SelectList>
  </div>
</template>

<script>
import { storeToRefs } from "pinia";

import SelectList from "src/components/common/SelectList.vue";
import { useGlobalAdminStore } from "src/stores/global";

export default {
  name: "AccountManagerDropdown",
  components: {
    SelectList,
  },
  props: {
    modelValue: {
      type: [Number, Object, String, null],
      default: null,
    },
    label: {
      type: String,
      default: "Account Manager",
    },
    optionLabel: {
      type: String,
      default: "name",
    },
    optionValue: {
      type: String,
      default: "id",
    },
    clearable: {
      type: Boolean,
    },
    dense: {
      type: Boolean,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    emitObject: {
      type: Boolean,
    },
    hideStackLabel: {
      type: Boolean,
    },
  },
  emits: ["update:modelValue"],
  setup() {
    const globalAdminStore = useGlobalAdminStore();
    const { accountManagers } = storeToRefs(globalAdminStore);

    return { accountManagers };
  },
  computed: {
    selectedValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    getLabel() {
      if (this.hideStackLabel && this.selectedValue) {
        return undefined;
      }

      return this.label;
    },
  },
};
</script>
